import { createCRUDHook } from './createCRUDHook';
import { CarouselImagesDto } from 'utils/models';
import { ECG_BANNER_CAROUSEL_IMAGES } from './apiEndPoints';

const { Context, useManager, useConsumer } = createCRUDHook<CarouselImagesDto>({
  entityName: 'CarouselImages',
  endpoint: ECG_BANNER_CAROUSEL_IMAGES,
});

export const CarouselImagesContext = Context;
export const useCarouselImagesManager = useManager;
export const useCarouselImages = useConsumer;
